<template>
  <v-container class="home">
    <div class="tariffs-block">
      <h1>ТАРИФЫ ДЛЯ СЕЛЛЕРОВ</h1>

      <p><strong>Тарифы на Справки по рекламным кампаниям рекламных агентств - рассчитывается по CPM модели:</strong></p>

      <table>
        <thead>
          <tr>
            <th rowspan="2">№ диапазона</th>
            <th colspan="2">Число показов рекламных роликов</th>
            <th rowspan="2">Стоимость, руб. за 1000 показов, без учета НДС</th>
          </tr>
          <tr>
            <th>От</th>
            <th>До</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>0</td><td>50 000 000</td><td>8,0</td></tr>
          <tr><td>2</td><td>50 000 001</td><td>100 000 000</td><td>6,0</td></tr>
          <tr><td>3</td><td>100 000 001</td><td>200 000 000</td><td>5,0</td></tr>
          <tr><td>4</td><td>200 000 001</td><td>500 000 000</td><td>3,0</td></tr>
          <tr><td>5</td><td>500 000 001</td><td>1 000 000 000</td><td>2,5</td></tr>
          <tr><td>6</td><td>1 000 000 001</td><td>1 500 000 000</td><td>2,0</td></tr>
        </tbody>
      </table>

      <p><strong>Тарифы формирования данных по социально-демографическим характеристикам - рассчитывается по CPM модели:</strong></p>

      <table>
        <thead>
          <tr>
            <th>Количество показов РИМ в месяц, шт.</th>
            <th>CPM, руб., без учета НДС</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1 - 200 000 000</td><td>11,0</td></tr>
          <tr><td>200 000 001 - 500 000 000</td><td>6,0</td></tr>
          <tr><td>500 000 001 - 1 000 000 000</td><td>5,5</td></tr>
          <tr><td>1 000 000 001 - 1 500 000 000</td><td>5,0</td></tr>
        </tbody>
      </table>

      <h1>ТАРИФЫ ДЛЯ РЕКЛАМНЫХ АГЕНТСТВ</h1>

      <h2>Тарифы на автоматические отчеты</h2>

      <h3>1. Post-Buying Analysis (PBA)</h3>

      <h4>1.1. Отчеты по кросс-медиа измерениям</h4>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Название</th>
            <th rowspan="2">Описание</th>
            <th colspan="2">Стоимость диджитал, руб. без учета НДС</th>
            <th rowspan="2">Стоимость присоединения ТВ-данных к одной РК, руб. без учета НДС</th>
          </tr>
          <tr>
            <th>Количество показов</th>
            <th>Цена, руб. без НДС</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="8">Отчеты по кросс-медиа измерениям (PBA)</td>
            <td rowspan="8">Подключение части или всех рекламных кампаний клиента в автоматический режим: ежедневная статистика по кампаниям + итоговый сводный отчет по завершению РК</td>
            <td>до 500 000</td>
            <td>15 000</td>
            <td rowspan="8">200 000 ₽</td>
          </tr>
          <tr><td>от 500 001 до 1000000</td><td>20 000</td></tr>
          <tr><td>от 1 000 001 до 5 000 000</td><td>100 000</td></tr>
          <tr><td>от 5 000 001 до 10 000 000</td><td>150 000</td></tr>
          <tr><td>от 10 000 001 до 50 000 000</td><td>300 000</td></tr>
          <tr><td>от 50 000 001 до 100 000 000</td><td>400 000</td></tr>
          <tr><td>от 100 000 001 до 200 000 000</td><td>375 000</td></tr>
          <tr><td>более 200 000 000</td><td>400 000</td></tr>
        </tbody>
      </table>

      <h4>Объемные скидки</h4>

      <table>
        <thead>
          <tr>
            <th>Нарастающее количество показов (с начала года), млн</th>
            <th>Скидка</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>200</td><td>15%</td></tr>
          <tr><td>300</td><td>30%</td></tr>
          <tr><td>600</td><td>35%</td></tr>
          <tr><td>1 200</td><td>40%</td></tr>
          <tr><td>3 000</td><td>50%</td></tr>
          <tr><td>6 000</td><td>60%</td></tr>
        </tbody>
      </table>

      <h4>1.2. Brand Lift и Traffic Lift</h4>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Название</th>
            <th rowspan="2">Описание</th>
            <th colspan="2">Стоимость диджитал, руб. без учета НДС</th>
            <th rowspan="2">Стоимость присоединения ТВ-данных к одной РК, руб. без учета НДС</th>
          </tr>
          <tr>
            <th>Количество показов</th>
            <th>Цена, руб. без НДС</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="4">Выгрузка для Brand Lift</td>
            <td rowspan="4">Данные для анализа эффективности РК по интернет-панелям (ORO/OMI/OnIn/Tiburon): количество контактов панелистов с РК, детализация частот (не видели / видели 1+…10+).</td>
            <td>до 1 000 000</td>
            <td>40 000</td>
            <td rowspan="4">200 000</td>
          </tr>
          <tr><td>от 1 000 001 до 5 000 000</td><td>100 000</td></tr>
          <tr><td>от 5 000 001 до 30 000 000</td><td>200 000</td></tr>
          <tr><td>более 30 000 000</td><td>270 000</td></tr>

          <tr>
            <td rowspan="4">Traffic Lift</td>
            <td rowspan="4">Анализ эффективности РК: переход на сайт клиента</td>
            <td>до 15 000 000</td>
            <td>200 000</td>
            <td rowspan="4">200 000</td>
          </tr>
          <tr><td>от 15 000 001 до 50 000 000</td><td>400 000</td></tr>
          <tr><td>от 50 000 001 до 100 000 000</td><td>540 000</td></tr>
          <tr><td>более 100 000 000</td><td>670 000</td></tr>

          <tr>
            <td rowspan="4">Traffic Lift (Pixel)</td>
            <td rowspan="4">Анализ эффективности РК: количество контактов + действия на сайте/в приложении Заказчика (визиты, события, конверсии). Требуется установка пикселя MediaHills на сайте и площадках.</td>
            <td>до 15 000 000</td>
            <td>40 000</td>
            <td rowspan="4">200 000</td>
          </tr>
          <tr><td>от 15 000 001 до 30 000 000</td><td>100 000</td></tr>
          <tr><td>от 30 000 001 до 100 000 000</td><td>200 000</td></tr>
          <tr><td>более 100 000 000</td><td>270 000</td></tr>
        </tbody>
      </table>

      <h4>Объемные скидки</h4>

      <table>
        <thead>
          <tr>
            <th>Нарастающее количество показов (с начала года), млн</th>
            <th>Скидка</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>75</td><td>15%</td></tr>
          <tr><td>150</td><td>25%</td></tr>
          <tr><td>300</td><td>35%</td></tr>
        </tbody>
      </table>

      <h2>Тарифы на ручные отчеты</h2>

      <h3>1. Post-Buying Analysis (PBA)</h3>

      <h4>1.1. Отчеты по кросс-медиа измерениям</h4>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Название</th>
            <th rowspan="2">Описание</th>
            <th colspan="2">Стоимость, руб. без учета НДС</th>
          </tr>
          <tr>
            <th>Диджитал</th>
            <th>Присоединение ТВ-данных к одной РК</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Разовый отчет по РК</td>
            <td>Итоговый отчет после завершения одной рекламной кампании. Содержит охваты, частоты, TRP/GRP, пересечения аудиторий по ТВ, Digital или по ТВ+Digital - 1 отчет/1 РК (до 2 мес.)/1 флайт/до 2 ЦА/до 2 ГЕО</td>
            <td>400 000</td>
            <td>300 000</td>
          </tr>
        </tbody>
      </table>

      <h4>1.2. Brand Lift и Traffic Lift</h4>

      <table>
        <thead>
          <tr>
            <th rowspan="2">Название</th>
            <th rowspan="2">Описание</th>
            <th colspan="2">Стоимость, руб. без учета НДС</th>
          </tr>
          <tr>
            <th>Диджитал</th>
            <th>Присоединение ТВ-данных к одной РК</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Brand Lift (разовый отчет)</td>
            <td>Данные для анализа эффективности РК по интернет-панелям (ORO/OMI/OnIn/Tiburon): количество контактов панелистов с РК, детализация частот (не видели / видели 1+…10+). Возможен как по всей кампании, так и по её части, до 2 ЦА/до 2 ГЕО</td>
            <td>400 000</td>
            <td>300 000</td>
          </tr>
          <tr>
            <td>Traffic Lift (разовый отчет)</td>
            <td>Анализ эффективности РК: количество контактов + действия на сайте/в приложении Заказчика (визиты, события, конверсии). Требуется установка пикселя MediaHills на сайте и площадках.</td>
            <td>650 000</td>
            <td>350 000</td>
          </tr>
        </tbody>
      </table>

      <h3>2. Наценки за дополнительные параметры для ручных отчетов</h3>

      <table>
        <thead>
          <tr>
            <th>Название</th>
            <th>Стоимость за 1 отчет, руб.</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Дополнительная стандартная ЦА</td><td>30 000,00</td></tr>
          <tr><td>Дополнительная ЦА не входящая в готовую сегментацию</td><td>110 000,00</td></tr>
          <tr><td>Дополнительный ГЕО</td><td>30 000,00</td></tr>
        </tbody>
      </table>

      <h3>3. Объемные скидки для ручных отчетов</h3>

      <table>
        <thead>
          <tr>
            <th>Условия</th>
            <th>Размер скидки, %</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>При заключении договора на 5 отчетов*</td><td>10%</td></tr>
          <tr><td>При заключении договора на 10 отчетов*</td><td>15%</td></tr>
          <tr><td>При заключении договора на 20 отчетов*</td><td>20%</td></tr>
          <tr><td>При заключении договора более чем на 20 отчетов*</td><td>обсуждается индивидуально</td></tr>
        </tbody>
      </table>

      <p class="tariffs-subnote">*при договоре на 12 месяцев.</p>

      <h1>ТАРИФЫ ДЛЯ ТЕМАТИЧЕСКИХ ТЕЛЕКАНАЛОВ</h1>

      <table>
        <thead>
          <tr>
            <th>№</th>
            <th>Группа</th>
            <th>Тип отчёта</th>
            <th>Период данных для 1 отчета</th>
            <th>Количество ЦА для 1 отчета</th>
            <th>Срок подготовки отчета</th>
            <th>Нац ТВ (вся Россия)</th>
            <th>Рег ТВ 1 город</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td rowspan="4">АНАЛИТИКА ТЕЛЕКАНАЛОВ И ТЕЛЕПЕРЕДАЧ</td>
            <td>Анализ показателей телепередач (тематические и федеральные телеканалы)</td>
            <td>до 10 трансляций</td>
            <td>до 2 ЦА</td>
            <td>3-5 рабочих дней</td>
            <td>300 000,00</td>
            <td>200 000,00</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Анализ показателей тематического телеканала</td>
            <td>1 квартал</td>
            <td></td>
            <td>15 рабочих дней</td>
            <td>150 000,00</td>
            <td>100 000,00</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Анализ спортивных трансляций</td>
            <td>до 200 трансляций</td>
            <td>до 2 ЦА</td>
            <td>15 рабочих дней</td>
            <td>400 000,00</td>
            <td>300 000,00</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Анализ сюжетов телепередачи</td>
            <td>1 телепередача продолжительностью до 2 часов</td>
            <td></td>
            <td>3-5 рабочих дней</td>
            <td>200 000,00</td>
            <td>150 000,00</td>
          </tr>
        </tbody>
      </table>

      <h1>ТАРИФЫ ДЛЯ РЕГИОНАЛЬНЫХ ТЕЛЕКАНАЛОВ</h1>

      <table>
        <thead>
          <tr>
            <th>№</th>
            <th>Группа</th>
            <th>Тип отчёта</th>
            <th>Период данных для 1 отчета</th>
            <th>Срок подготовки отчета</th>
            <th>Стоимость, руб. без НДС</th>
            <th>Наценка за доп. город в отчёте Рег ТВ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>PBA</td>
            <td>Данные по накопленному охвату по передачам</td>
            <td>1 календарный месяц, 1 телеканал, 1 город/1 регион (total)</td>
            <td>по запросу</td>
            <td>10% от стоимости основного договора</td>
            <td>30% от тарифа</td>
          </tr>
          <tr>
            <td rowspan="3">5</td>
            <td rowspan="3">АНАЛИТИКА ТЕЛЕКАНАЛОВ И ТЕЛЕПЕРЕДАЧ</td>
            <td>Анализ показателей телепередач (региональные телеканалы)</td>
            <td>1 телепередача, до 2 региональных ТК</td>
            <td>3-5 рабочих дней</td>
            <td>15 000,00</td>
            <td></td>
          </tr>
          <tr>
            <td>Анализ показателей регионального телеканала (портрет телеканала)</td>
            <td>1 квартал, 1 телеканал, 1 город/1 регион (total)</td>
            <td>21 рабочий день</td>
            <td>50 000,00</td>
            <td>20 000,00</td>
          </tr>
          <tr>
            <td>Анализ спортивных трансляций</td>
            <td>до 200 трансляций, 1 региональный телеканал</td>
            <td>21 рабочий день</td>
            <td>300 000,00</td>
            <td>50 000,00</td>
          </tr>
          <tr>
            <td>6</td>
            <td>ГОДОВАЯ ПОДПИСКА НА ЕЖЕМЕСЯЧНЫЙ СВОДНЫЙ ОТЧЕТ по 21/22 КНОПКАМ РФ</td>
            <td>Сводные данные 21/22 кнопок</td>
            <td>1 календарный месяц</td>
            <td>до 20 числа месяца, следующего за отчетным</td>
            <td>50 000,00</td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <p class="tariffs-note">Все цены без учета НДС. НДС оплачивается Заказчиком дополнительно</p>
    </div>
    <footer-block />
  </v-container>
</template>
<style>
  .tariffs-block {
    font-family: Arial, sans-serif;
    line-height: 1.5;
    color: #222;
    width: 70%;
    margin: 0 auto;  
  }

  .tariffs-block h1 {
    font-size: 24px;
    margin: 24px 0 12px;
  }

  .tariffs-block h2 {
    font-size: 18px;
    margin: 18px 0 10px;
  }

  .tariffs-block h3 {
    font-size: 16px;
    margin: 16px 0 8px;
  }

  .tariffs-block h4 {
    font-size: 15px;
    margin: 14px 0 8px;
  }

  .tariffs-block p {
    margin: 0 0 12px;
  }

  .tariffs-block table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 24px;
    font-size: 14px;
  }

  .tariffs-block th,
  .tariffs-block td {
    border: 1px solid #dcdcdc;
    padding: 8px 10px;
    text-align: center;
    vertical-align: center;
  }

  .tariffs-block th {
    background: #f5f5f5;
    font-weight: 700;
  }

  .tariffs-block tbody tr:nth-child(even) {
    background: #fafafa;
  }

  .tariffs-block .tariffs-note {
    font-weight: 700;
    margin-top: 20px;
  }

  .tariffs-block .tariffs-subnote {
    font-size: 13px;
  }
</style>

<script>
import FooterBlock from "@/components/Footer";


export default {
  name: "About",
  components: { FooterBlock},
  data() {
    return {
    };
  },
  mounted() {
    const formatNumbers = (text) => {
      return text.replace(/\b\d{1,3}( \d{3})+( ₽)?\b/g, (match) => {
        return match.replace(/ /g, '&nbsp;');
      });
    };

    document.querySelectorAll('.tariffs-block td, .tariffs-block th, .tariffs-block p').forEach(el => {
      el.innerHTML = formatNumbers(el.innerHTML);
    });
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style lang="scss">
</style>
